import styled from "styled-components";

export const TopDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;

`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

`;
export const ContainerCenter = styled.div`
  
  width: 80%;
  max-width: 1440px;
  margin: 0 auto;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;

`;

export const ContainerCenterInside = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  
`;
